import React from 'react';
import FriendsList from "../../../components/Friends/FriendsList";
import {canonical} from "../../../../libs/helper";
import createLink from "../../../../libs/createLink";
import Helmet from "react-helmet/es/Helmet";

const ProfileFriends = (props) => {
    let userContent = props.user && props.user.profile && props.user.profile.description ? props.user.profile.description : "";
    return (
        <div className={"main-wrapper card big profile-friends"}>
            <Helmet>
                <title>Profil Voissa de {props.user.username}</title>
                <meta name="description" content={userContent.substring(0, 140)} />
                <link rel="canonical" href={canonical(createLink('userProfile', props.user), "", "profile")} />
            </Helmet>
            <FriendsList type="profileFriends" {...props} isMe={props.isMe} user={props.user} displayTitle={true}
                         displayFriendsSearch={true}/>
        </div>
    )
};

export default ProfileFriends;